export default "__VITE_ASSET__i38R$eR___"